module.exports = __webpack_public_path__ + "img/szulinapi-01.0cefe137.png";